import React from 'react';
import { clsx } from 'js/app/utils/clsx.util';
import { componentService } from 'js/services/component.service';

import style from './Loader.scss';

// core, added theme
export const Loader = ({ className = '', theme = '' }) => (
    <div
        data-testid="Loader"
        className={clsx(style.loader, className, style[theme], 'loader')}
    >
        <div className={style.rect1} />
        <div className={style.rect2} />
    </div>
);

componentService.registerWebContentComponents({ Loader });
